import {
  GET_PRIORITY_ORDERS,
  GET_PRIORITY_ORDERS_SUCCESS,
  GET_PRIORITY_ORDERS_FAIL,
  ADD_PRIORITY_ORDER,
  ADD_PRIORITY_ORDER_SUCCESS,
  ADD_PRIORITY_ORDER_FAIL,
  UPDATE_PRIORITY_ORDER,
  UPDATE_PRIORITY_ORDER_SUCCESS,
  UPDATE_PRIORITY_ORDER_FAIL,
  DELETE_PRIORITY_ORDER,
  DELETE_PRIORITY_ORDER_SUCCESS,
  DELETE_PRIORITY_ORDER_FAIL,
  GET_SPEC_PRIORITY_ORDERS,
  GET_SPEC_PRIORITY_ORDERS_SUCCESS,
  GET_SPEC_PRIORITY_ORDERS_FAIL,
  GET_ACRHIVE_PRIORITY_ORDERS,
  GET_ACRHIVE_PRIORITY_ORDERS_SUCCESS,
  GET_ACRHIVE_PRIORITY_ORDERS_FAIL,
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

// GET ALL PRIORITY ORDERS
export const getPriorityOrders = () => ({
  type: GET_PRIORITY_ORDERS
});
export const getPriorityOrdersSuccess = (priority_orders) => ({
  type: GET_PRIORITY_ORDERS_SUCCESS,
  payload: priority_orders
});
export const getPriorityOrdersFail = error => ({
  type: GET_PRIORITY_ORDERS_FAIL,
  payload: error,
})
//GET ARCHIVE ORDERS
export const getArchivePriorityOrders = (priority_orders) => ({
  type: GET_ACRHIVE_PRIORITY_ORDERS,
  payload: priority_orders
});
export const getArchivePriorityOrdersSuccess = (priority_orders) => ({
  type: GET_ACRHIVE_PRIORITY_ORDERS_SUCCESS,
  payload: priority_orders
});
export const getArchivePriorityOrdersFail = (error) => ({
  type: GET_ACRHIVE_PRIORITY_ORDERS_FAIL,
  payload: error
});
//GET SPECIFIC ORDERS
export const getSpecPriorityOrders = (priority_orders) => ({
  type: GET_SPEC_PRIORITY_ORDERS,
  payload: priority_orders
});
export const getSpecPriorityOrdersSuccess = (priority_orders) => ({
  type: GET_SPEC_PRIORITY_ORDERS_SUCCESS,
  payload: priority_orders
});
export const getSpecPriorityOrdersFail = (error) => ({
  type: GET_SPEC_PRIORITY_ORDERS_FAIL,
  payload: error
});
// GET HISTORY DATA
export const getHistoryData = (priority_order) => ({
  type: GET_HISTORY,
  payload: priority_order
});
export const getHistoryDataSuccess = (priority_order) => ({
  type: GET_HISTORY_SUCCESS,
  payload: priority_order
});
export const getHistoryDataFail = (error) => ({
  type: GET_HISTORY_FAIL,
  payload: error
});
// ADD NEW PRIORITY ORDER
export const addPriorityOrder = (priority_order) => ({
  type: ADD_PRIORITY_ORDER,
  payload: priority_order
});
export const addPriorityOrderSuccess = priority_order => ({
  type: ADD_PRIORITY_ORDER_SUCCESS,
  payload: priority_order,
})
export const addPriorityOrderFail = error => ({
  type: ADD_PRIORITY_ORDER_FAIL,
  payload: error,
})
// UPDATE ORDER INSIDE PRIORITY ORDER
export const updatePriorityOrder = (priority_order) => ({
  type: UPDATE_PRIORITY_ORDER,
  payload: priority_order
});
export const updatePriorityOrderSuccess = priority_order => ({
  type: UPDATE_PRIORITY_ORDER_SUCCESS,
  payload: priority_order,
})
export const updatePriorityOrderFail = error => ({
  type: UPDATE_PRIORITY_ORDER_FAIL,
  payload: error,
})
// DELETE ORDER FROM BATTLEFEILD TABLE
export const deletePriorityOrder = (priority_order) => ({
  type: DELETE_PRIORITY_ORDER,
  payload: priority_order
});
export const deletePriorityOrderSuccess = priority_order => ({
  type: DELETE_PRIORITY_ORDER_SUCCESS,
  payload: priority_order,
})
export const deletePriorityOrderFail = error => ({
  type: DELETE_PRIORITY_ORDER_FAIL,
  payload: error,
})

export const showLoading = (status) => ({
  type: SHOW_LOADING,
  payload: status
});
export const hideLoading = (status) => ({
  type: HIDE_LOADING,
  payload: status
});
